import * as StM from '../../models/store';
import BaseReducer from '../baseReducer';
import * as _ from 'lodash';

export default class EditPackageDialogReducer extends BaseReducer {
    static handle(state: StM.IEditPackageDialogStoreState = new StM.EditPackageDialogStoreState(), action: any): StM.IEditPackageDialogStoreState {
        switch (action.type) {
            case 'Dialogs/Admin/EditPackage/Open': {
                return <StM.IEditCoachFeeTierDialogStoreState>_.assign({}, state, { isOpened: true, id: action.id });
            }
            case 'Dialogs/Admin/EditPackage/Close': {
                return <StM.IEditCoachFeeTierDialogStoreState>_.assign({}, state, { isOpened: false });
            }
            default: {
                return state;
            }
        }
    }
}
